import { RefObject } from "react";

export enum Trigger {
	Mouse,
	Keyboard,
}

/**
 * Sets focus while taking into account the polyfill "focus-visible".
 * See info here: [polyfill Githup repository](https://github.com/WICG/focus-visible)
 * @param element - element to add focus for.
 * @param trigger - whether it's a keyboard or mouse interaction, if keyboard, the function will
 *  also remove "focus-visible" class from all elements and applies it to this element.
 */
export function setFocus(element: HTMLElement, trigger: Trigger = Trigger.Keyboard): void {
	const fv = "focus-visible";
	const els = document.getElementsByClassName(fv);

	for (let i = 0; i < els.length; i++) {
		els[i].classList.remove(fv);
	}

	element.focus();

	if (trigger === Trigger.Keyboard && document.activeElement === element) {
		element.classList.add(fv);
	}
}

/**
 * Checks if the target of an event is contained in the ref
 */

export function isTargetRef<T extends HTMLElement>(
	t: EventTarget | null,
	ref: RefObject<T>
): boolean | null {
	return ref.current && t instanceof Node && ref.current.contains(t);
}
